window.settings = {
    init() {
        this.colorTypes = ['key', 'court', 'runoff'];
        this.settings = {
            colours: {
                key: {
                    name: "Orange",
                    colour: "EB6724"
                },
                court: {
                    name: "Titanium",
                    colour: "88A0AA"
                }
            },
        };
        this.listeners();
        return this;
    },
    getColour(value) {
        if (this.products) {
            if (this.products.colours) {
                value == "000000" ? value = "000" : value;
                return Object.values(this.products.colours).find(el => el.colour == value.replace("#", ""));
            }
        }
    },
    setColour(type, name, value) {
        this.colorTypes.forEach(elType => {
            if (type == elType) {
                this.settings.colours[elType] = this.getColour(name, value);
            }
        })
    },
    changeSettings() {
        let col1 = this.findGetParameter('col1'),
            col2 = this.findGetParameter('col2');
        // set colours
        col1 ? this.setColour("key", col1) : null;
        col2 ? this.setColour("court", col2) : null;
    },
    listeners() {
        this.changeSettings();
    },
    findGetParameter(parameterName) {
        // return (new URLSearchParams(window.location.search).get(name));
        var result = null,
            tmp = [];
        location.search.substr(1).split("&").forEach(function (item) {
            tmp = item.split("=");
            if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
        return result;
    }
}.init();